// =============================================================================
// partnerRelation (frontend) — Issue #1862.
//
// The browser half of supabase/functions/_shared/partnerRelation.ts. Carries
// the stored vocabulary and the button labels only; the prompt phrasing lives
// in the shared file because its callers are edge functions.
//
// ⚠️ The value strings here are the SAME strings the shared module parses, and
// nothing at runtime connects the two files — src/ never imports from
// supabase/functions/ (only tests do). src/lib/__tests__/partnerRelation.test.ts
// imports both and asserts they match. Same shape as kidGender.ts.
// =============================================================================

export type PartnerRelation = "husband" | "wife" | "partner";

export const PARTNER_RELATION_VALUES: readonly PartnerRelation[] = [
  "husband",
  "wife",
  "partner",
] as const;

/** `family_context.key`. Must equal PARTNER_RELATION_FACT_KEY in the shared module. */
export const PARTNER_RELATION_FACT_KEY = "partner_relation";

/** Button copy. The STORED value stays lowercase — see kidGender.ts for why
 *  this is a map and not a toUpperCase() of the value. */
export const PARTNER_RELATION_LABELS: Record<PartnerRelation, string> = {
  husband: "Husband",
  wife: "Wife",
  partner: "Partner",
};

/** Mirror of the shared normalizer, synonyms included. Parity-tested. */
export function normalizePartnerRelation(raw: unknown): PartnerRelation | null {
  if (typeof raw !== "string") return null;
  const v = raw.trim().toLowerCase();
  if (v === "husband" || v === "hubby") return "husband";
  if (v === "wife") return "wife";
  if (v === "partner" || v === "spouse" || v === "significant other") return "partner";
  return null;
}
